export default __webpack_public_path__ + "static/media/hubnmaillogo.1fcc959d.png";